module.exports = __webpack_public_path__ + "img/clickbait-dark.b7d48445.svg";